import type { FormSubmitData } from '../form/form.types.js';

/**
 * Splits the single `onSubmit` callback back into one spy per outcome.
 *
 * `onSubmit` fires once per trigger, before validation, and carries the
 * outcome on `validationResult`. Most tests only care about which branch was
 * taken, so this keeps them reading the way they did when `onSubmit` and
 * `onInvalid` were separate props.
 *
 * `valid` receives the snapshot, `invalid` receives every error present when
 * the run settled, and `aborted` takes no argument — a cancelled run has no verdict to report.
 */
export function createSubmitSpies() {
  const valid = jest.fn();
  const invalid = jest.fn();
  const aborted = jest.fn();

  const onSubmit = jest.fn(async ({ validationResult }: FormSubmitData) => {
    const result = await validationResult;
    if (result.validity === 'valid') {
      valid(result.snapshot);
    } else if (result.validity === 'invalid') {
      invalid(result.errors);
    } else {
      aborted();
    }
  });

  return { onSubmit, valid, invalid, aborted };
}
